export default "__VITE_ASSET__Dl$N5qyz__"